const EventRoutes = {
  getAdvisionEvents: "/event/getAllEventAdvision",
  getDragonEvents: "/event/getAllEventDragon",
  getEvents: "/userEvent/getEvents",
  sendEmail: "/userEvent/sendMail"
};

export default EventRoutes;